<template>
  <v-dialog
    id="AlertDialogComponent"
    v-model="alertDialog.show"
    max-width="350"
    attach
  >
    <v-card>
      <v-card-title primary-title>
        {{ alertDialog.title }}
      </v-card-title>
      <v-card-text>
        {{ alertDialog.message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="success"
          @click="close()"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'AlertDialogComponent',
  props: {
    alertDialog: {
      type: Object,
      default: () => {
        return {
          show: false,
          title: '',
          message: ''
        }
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    close () {
      this.$emit('closeAlert')
    }
  }
}
</script>
<style lang='scss'>
    #AlertDialogComponent {
     //
    }
</style>
